import Colors from '@/utils/Colors'

export default class BaseColor extends Colors {
}
